import { api } from "./api";

const BrikServices = {
  createBrik: (params: any) => {
    return api.authPostForm("auth/owner/brik", params);
  },

  updateBrik: (id: string, params: any) => {
    return api.authPutForm(`/auth/owner/brik/${id}`, params);
  },

  getListBrik: (params: any) => {
    return api.authGet(`/auth/owner/brik`, params);
  },

  createSection: (id: string, params: any) => {
    return api.authPost(`/auth/owner/brik/${id}/section`, params);
  },

  createLength: (id: string, params: any) => {
    return api.authPost(`/auth/owner/brik/${id}/time`, params);
  },

  createDay: (brik_id: string, week_id: string, params: any) => {
    return api.authPost(`/auth/owner/brik/${brik_id}/time/${week_id}`, params);
  },

  createSubSection: (
    brik_id: string,
    section_id: string,
    params: any,
    sub_id?: any
  ) => {
    if (sub_id) {
      return api.authPutForm(
        `/auth/owner/brik/${brik_id}/section/${section_id}/sub/${sub_id}`,
        params
      );
    } else {
      return api.authPostForm(
        `/auth/owner/brik/${brik_id}/section/${section_id}/sub`,
        params
      );
    }
  },

  orderSubSection: (brik_id: string, section_id: string, params: any) => {
    return api.authPut(
      `/auth/owner/brik/${brik_id}/section/${section_id}/sub/order`,
      params
    );
  },

  deleteSubSection: (brik_id: string, section_id: string, sub_id?: any) => {
    return api.authDelete(
      `/auth/owner/brik/${brik_id}/section/${section_id}/sub/${sub_id}`
    );
  },

  getBrikDetail: (brik_id: string) => {
    return api.authGet(`/auth/owner/brik/${brik_id}`);
  },

  getListSection: (brik_id: string, params?: any) => {
    return api.authGet(`/auth/owner/brik/${brik_id}/section`, params);
  },

  getNameSubSection: () => {
    return api.authGet(`/auth/owner/brik/sub-section`);
  },

  updateSection: (brik_id: string, section_id: string, params: any) => {
    return api.authPut(
      `/auth/owner/brik/${brik_id}/section/${section_id}`,
      params
    );
  },

  orderSection: (brik_id: string, params: any) => {
    return api.authPut(`/auth/owner/brik/${brik_id}/section/order`, params);
  },

  createContent: (
    brik_id: string,
    section_id: string,
    sub_id: string,
    params: any
  ) => {
    return api.authPost(
      `/auth/owner/brik/${brik_id}/section/${section_id}/sub/${sub_id}/content`,
      params
    );
  },

  updateContent: (
    brik_id: string,
    section_id: string,
    sub_id: string,
    content_id: string,
    params: any
  ) => {
    return api.authPut(
      `/auth/owner/brik/${brik_id}/section/${section_id}/sub/${sub_id}/content/${content_id}`,
      params
    );
  },

  orderContent: (
    brik_id: string,
    section_id: string,
    sub_id: string,
    params: any
  ) => {
    return api.authPut(
      `/auth/owner/brik/${brik_id}/section/${section_id}/sub/${sub_id}/content/order`,
      params
    );
  },

  deleteSection: (brik_id: string, section_id: string) => {
    return api.authDelete(`/auth/owner/brik/${brik_id}/section/${section_id}`);
  },

  deleteContent: (
    brik_id: string,
    section_id: string,
    sub_id: string,
    content_id: string
  ) => {
    return api.authDelete(
      `/auth/owner/brik/${brik_id}/section/${section_id}/sub/${sub_id}/content/${content_id}`
    );
  },

  duplicateBrik: (brik_id: string, params: any) => {
    return api.authPostForm(`/auth/owner/brik/${brik_id}/duplicate`, params);
  },

  duplicateSection: (brik_id: string, section_id: string, params: any) => {
    return api.authPostForm(
      `/auth/owner/brik/${brik_id}/section/${section_id}/duplicate`,
      params
    );
  },

  shareBrik: (brik_id: string, params: any) => {
    return api.authPost(`/auth/owner/brik/${brik_id}/share`, params);
  },

  getListShare: (brik_id: string, params: any) => {
    return api.authGet(`/auth/owner/brik/${brik_id}/share`, params);
  },

  deleteBrik: (brik_id: string) => {
    return api.authDelete(`/auth/owner/brik/${brik_id}`);
  },

  deleteLength: (brik_id: string, length_id: string) => {
    return api.authDelete(`/auth/owner/brik/${brik_id}/time/${length_id}`);
  },

  deleteDay: (brik_id: string, length_id: string, day_id: string) => {
    return api.authDelete(
      `/auth/owner/brik/${brik_id}/time/${length_id}/day/${day_id}`
    );
  },
  changeStatus: (brik_id: string) => {
    return api.authPut(`/auth/owner/brik/${brik_id}/status`);
  },

  duplicateLength: (brik_id: string, length_id: any) => {
    return api.authPost(
      `/auth/owner/brik/${brik_id}/time/${length_id}/duplicate`
    );
  },

  duplicateDay: (brik_id: string, length_id: any, day_id: any, params: any) => {
    return api.authPost(
      `/auth/owner/brik/${brik_id}/time/${length_id}/day/${day_id}/duplicate`,
      params
    );
  },

  listSharedData: (brik_id: string) => {
    return api.authGet(`/auth/owner/brik/${brik_id}/shared`);
  },

  unshareBrik: (brik_id: string, params: any) => {
    return api.authDelete(`/auth/owner/brik/${brik_id}/unshare`, params);
  },

  deleteAllSubSection: (
    brik_id: string,
    section_id: string,
    day_id: string
  ) => {
    return api.authDelete(
      `/auth/owner/brik/${brik_id}/section/${section_id}/day/${day_id}/deleteAll`
    );
  },

  deleteDayAllSubSection: (brik_id: string, section_id: string) => {
    return api.authDelete(
      `/auth/owner/brik/${brik_id}/section/${section_id}/deleteAll`
    );
  },

  orderLength: (brik_id: string, params: any) => {
    return api.authPost(`/auth/owner/brik/${brik_id}/time/order`, params);
  },

  orderDays: (brik_id: string, params: any) => {
    return api.authPost(
      `/auth/owner/brik/${brik_id}/time/dragDays`,
      params
    );
  },

  dragBrik: (
    brik_id: string,
    section_id: string,
    params: { day_id: number; week_id: number; order: number }
  ) => {
    return api.authPut(
      `/auth/owner/brik/${brik_id}/section/${section_id}/drag`,
      params
    );
  },
};

export default BrikServices;
